<template>
  <div class="container section-about" id="section-about" data-aos="fade-up" data-aos-once="true">
    <div class="columns is-gapless is-centered">
      <div class="column has-text-centered">
        <img src="../assets/logo.svg" width="50" style="width:50px;" />
      </div>
    </div>
    <div class="columns is-gapless is-centered">
      <div class="column is-7 has-text-centered" v-html="paragraph.content" />
    </div>
    <!-- <div class="control notification is-danger" v-if="error">
      <button class="delete" @click="error = undefined"></button>
      <p v-html="error">
      </p>
    </div> -->
  </div>
</template>

<script>
  import Site from '@/apis/Site'
  import ShowDown from 'showdown'

  export default {
    name: 'about',
    components: {
    },
    data () {
      return {
        paragraph: {
          title: '',
          content: ''
        },
        error: undefined,
        loading: false
      }
    },
    computed: {
    },
    watch: {
    },
    created () {
    },
    mounted () {
      this.refresh()
    },
    methods: {
      onScrollTo: function (name) {
        this.$scrollTo('#' + name)
      }.bind(this),

      getItems: function (onComplete) {
        this.loading = true
        this.error = undefined
        this.paragraph.content = ''
        this.paragraph.title = ''
        Site.about()
        .then((data) => {
          this.loading = false
          // console.log(data)
          if (data && data.content) {
            var converter = new ShowDown.Converter()
            var html = converter.makeHtml(data.content)
            this.paragraph.content = html
            this.paragraph.title = data.title
          } else {
            this.error = 'Unable to load, please kindly refresh the page.'
          }

          if (onComplete) {
            onComplete(data)
          }
        })
        .catch((error) => {
          this.loading = false
          this.error = 'Unable to load, please kindly refresh the page.'
          console.log(error)
        })
      },
      refresh: function () {
        this.getItems((item) => {
          // this.item = item
        })
      }
    }
  }
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

// section about

.section-about {
  margin-top: 5em;
  margin-bottom: 8em;

  .title:not(:last-child),
  .subtitle:not(:last-child) {
    padding-left: 0.75em;
    padding-right: 0.75em;
    margin-bottom: 0.1em;
  }

  .title:last-child,
  .subtitle:last-child {
    padding-left: 0.75em;
    padding-right: 0.75em;
    margin-bottom: 1em;
  }

  p {
    font-size: 1.1em;
    line-height: 1.8em;
    text-align: center;
    padding-left: 0.75em;
    padding-right: 0.75em;

    &:not(:first-child) {
      margin-top: 1em;
      @media screen and (min-width: $tablet) {
        margin-top: 1em;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// AboutSection.vue?53ddbf1f